export const utilsLog = (message, logType = "") => {
  if (!import.meta.env.DEV) return;

  switch (logType) {
    case "warn":
      console.warn(message);
      break;
    case "error":
      console.error(message);
      break;
    default:
      console.log(message);
      break;
  }
}
